import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequestsState } from '../../../../../portals/store/src/lib/states/requests.state'

@Component({
  selector: 'portals-collect-email',
  templateUrl: './collect-email.component.html',
  styleUrls: ['./collect-email.component.scss'],
})
export class CollectEmailComponent implements OnInit {
  emailForm: FormGroup;
  emailSent = false;
  emailSending = false;
  errorMessage = '';

  constructor(private fb: FormBuilder, private http: HttpClient, private requestsState: RequestsState) {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {}

  sendEmail() {
    if (this.emailForm.invalid) {
      this.errorMessage = 'Please enter a valid email.';
      return;
    }

    this.errorMessage = '';
    this.emailSending = true;
    const email = this.emailForm.get('email')?.value;

    this.createRequest({data: { email, context: 'Jotto_Contact' }});
  }

  createRequest(form: any) {
    this.requestsState.create(form).subscribe({
      next: (response) => {
        this.emailSent = true;
        this.emailSending = false;
        // Handle successful creation here
        console.log('Request created successfully', response);
      },
      error: (error) => {
        this.emailSending = false;
        this.errorMessage = 'An error occurred while sending the email.';
        // Handle error here
        console.error('Error creating request', error);
      }
    });
  }
}
